// Which screen the app is on, plus the multiplayer lobby that feeds it.
// Extracted from App.tsx (ROADMAP 7.14); the hook order is unchanged.

import { useEffect, useState } from 'react';
import { type GameMode, shouldConnectMpLobby } from '../multiplayer/lobby/shouldConnectMpLobby.js';
import { useMpLobby } from '../multiplayer/lobby/useMpLobby.js';
import type { MatchInfo } from '../multiplayer/types.js';
import { watchFromSearch } from '../spectate/watchLink.js';

export function useGameFlow() {
  // A `?watch=<matchId>` link opens the read-only viewer straight away.
  const [watchId, setWatchId] = useState<string | null>(() =>
    typeof window === 'undefined' ? null : watchFromSearch(window.location.search),
  );
  const [gameMode, setGameMode] = useState<GameMode>(() =>
    typeof window !== 'undefined' && watchFromSearch(window.location.search) ? 'spectate' : 'menu',
  );
  const [localPlayerName, setLocalPlayerName] = useState(
    () => localStorage.getItem('aod_player_name') ?? '',
  );
  const [mpMatchInfo, setMpMatchInfo] = useState<MatchInfo | null>(null);

  const mpLobby = useMpLobby(undefined, shouldConnectMpLobby(gameMode));

  useEffect(() => {
    return mpLobby.onMatchFound((info) => {
      setMpMatchInfo(info);
      setGameMode('multiplayer-match');
    });
  }, [mpLobby]);

  return {
    watchId,
    setWatchId,
    gameMode,
    setGameMode,
    localPlayerName,
    setLocalPlayerName,
    mpMatchInfo,
    setMpMatchInfo,
    mpLobby,
  };
}
